(function () {
  function run() {
    const destination = document.querySelector('.js-copy-destination');
    if (!destination) return;

    document.querySelectorAll('.js-copy-block').forEach(function (block) {
      destination.insertAdjacentHTML('beforeend', block.innerHTML);
      block.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
